import React, { useContext, useEffect } from 'react'
import { Route, Routes, useLocation } from "react-router-dom";

import { getToken } from '../utils/sessionStorage'
import { protectedRoutes, openRoutes } from '../routes/routes'
import { FromContext } from '../data/FromContext'

import { UserWaiter } from './middlewares/UserWaiter'
import { DataWaiter } from './middlewares/DataWaiter'
import { Layout } from './Layout'
import { PrivateRoute } from './common/PrivateRoute'

const privateRoute = (r) => {
  const Component = r.component
  return (
  <Route exact={r.exact ?? true}
    key={r.link}
    path={r.link}
    element={
        <PrivateRoute
          roles={r.roles}
          canUseInternshipPermission={r.canUseInternshipPermission}
          isInternshipDirector={r.isInternshipDirector}>
            <Component/>
        </PrivateRoute>
      }
    />
  )
}
const route = (r) => {
  const Component = r.component
  return (<Route exact={r.exact ?? true} key={r.link} path={r.link} element={<Component/>}/>)
}

// need to wrap withRouter because it wouldn't be rerendered otherwise

export const RoutesHandler = () => {
  const location = useLocation()
  const token = getToken()
  const { setFrom } = useContext(FromContext)
  useEffect(() => {
    if (!token) {
      setFrom(location.pathname)
    }
  }, [location.pathname, token, setFrom])
  if (!token) {
    return (
      // for some reason Switch doesnt find location in its context, dont know why ....
      <Routes location={location.location}>
        {openRoutes.map(route)}
      </Routes>
    )
  }

  return (
    <UserWaiter>
      <DataWaiter>
        <Layout>
          {/* Same here. */}
          <Routes location={location.location}>
            {protectedRoutes.map(privateRoute)}
          </Routes>
        </Layout>
      </DataWaiter>
    </UserWaiter>
  )
}
